import { useState } from 'react';

interface Props {
  images: string[];
  carName: string;
  maxWidth?: string; // NEW
}

export default function CarGallery({ images, carName, maxWidth = '100%' }: Props) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex((p) => (p + 1) % images.length);
  const prev = () => setCurrentIndex((p) => (p === 0 ? images.length - 1 : p - 1));

  return (
    // Outer centers the gallery in full-width band
    <div style={{ width: '100%', background: '#080808', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth }}>

        {/* MAIN IMAGE */}
        <div style={mainWrap}>
          <img src={images[currentIndex]} alt={carName} style={mainImg} />
          {images.length > 1 && (
            <>
              <button onClick={prev} style={{ ...arrow, left: '12px' }}>‹</button>
              <button onClick={next} style={{ ...arrow, right: '12px' }}>›</button>
            </>
          )}
          <div style={counter}>{currentIndex + 1} / {images.length}</div>
        </div>

        {/* THUMBNAILS */}
        {images.length > 1 && (
          <div style={thumbContainer}>
            {images.map((img, index) => (
              <div
                key={index}
                onClick={() => setCurrentIndex(index)}
                style={{
                  ...thumb,
                  border: currentIndex === index
                    ? '2px solid #FFD700'
                    : '2px solid transparent',
                  opacity: currentIndex === index ? 1 : 0.5,
                }}
              >
                <img src={img} alt="" style={thumbImg} />
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

const mainWrap: React.CSSProperties = {
  position: 'relative',
  width: '100%',
  height: 'clamp(220px, 40vw, 480px)',
  overflow: 'hidden',
  background: '#111',
};

const mainImg: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
};

const arrow: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'rgba(0,0,0,0.55)',
  color: '#fff',
  border: '1px solid rgba(255,255,255,0.15)',
  fontSize: '22px',
  lineHeight: 1,
  padding: '8px 14px',
  cursor: 'pointer',
  borderRadius: '6px',
  backdropFilter: 'blur(4px)',
  transition: 'background 0.2s',
};

const counter: React.CSSProperties = {
  position: 'absolute',
  bottom: '12px',
  right: '12px',
  background: 'rgba(0,0,0,0.65)',
  color: '#ddd',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  letterSpacing: '0.05em',
};

const thumbContainer: React.CSSProperties = {
  display: 'flex',
  gap: '8px',
  padding: '10px 12px',
  overflowX: 'auto',
  background: '#0d0d0d',
  borderTop: '1px solid #1e1e1e',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
};

const thumb: React.CSSProperties = {
  minWidth: '80px',
  width: '80px',
  height: '56px',
  borderRadius: '5px',
  overflow: 'hidden',
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'opacity 0.2s, border-color 0.2s',
};

const thumbImg: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
};